import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Award, Zap, Wrench, Leaf } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import teamConstructionSiteV2Image from "@/assets/team-construction-site-v2.png";

const AboutSection = () => {
  const { t } = useTranslation();
  
  const values = [
    { title: t('about.valuesList.one.title'), description: t('about.valuesList.one.description'), icon: Award },
    { title: t('about.valuesList.two.title'), description: t('about.valuesList.two.description'), icon: Zap },
    { title: t('about.valuesList.three.title'), description: t('about.valuesList.three.description'), icon: Wrench },
    { title: t('about.valuesList.four.title'), description: t('about.valuesList.four.description'), icon: Leaf }
  ];

  return (
    <section id="nosotros" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-enausa-navy mb-6">
              {t('about.title')}
            </h2>
            <div className="space-y-6">
            <p className="text-lg text-enausa-gray leading-relaxed">
              {t('about.description')}
            </p>
              <p className="text-lg text-enausa-gray leading-relaxed">
                {t('about.subtitle')}
              </p>
            <div className="bg-enausa-light p-6 rounded-lg border-l-4 border-enausa-navy">
              <h3 className="text-xl font-semibold text-enausa-navy mb-2">{t('about.mission')}</h3>
              <p className="text-enausa-gray">
                {t('about.missionText')}
              </p>
            </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-strong">
              <img 
                src={teamConstructionSiteV2Image} 
                alt="Equipo profesional de ENAUSA en obra - nuestro talentoso equipo de ingenieros y técnicos especializados trabajando en sitio de construcción"
                className="w-full h-[500px] object-cover object-center"
                loading="lazy"
                decoding="async"
                width="384"
                height="384"
                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 384px"
              />
              
            </div>
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
             <Card key={index} className="text-center shadow-medium hover:shadow-strong transition-all duration-300 group bg-gradient-card">
               <CardHeader className="pb-4">
                 <div className="w-16 h-16 bg-enausa-navy rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-medium">
                   <value.icon className="w-8 h-8 text-white" />
                 </div>
                 <CardTitle className="text-lg text-enausa-navy">{value.title}</CardTitle>
               </CardHeader>
              <CardContent>
                <CardDescription className="text-enausa-gray">{value.description}</CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Process Overview */}
        <div className="mt-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-enausa-navy mb-4">
              {t('about.process.title')}
            </h3>
            <p className="text-xl text-enausa-gray max-w-3xl mx-auto">
              {t('about.process.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {[
              { step: '1', title: t('about.process.steps.s1.title'), desc: t('about.process.steps.s1.desc') },
              { step: '2', title: t('about.process.steps.s2.title'), desc: t('about.process.steps.s2.desc') },
              { step: '3', title: t('about.process.steps.s3.title'), desc: t('about.process.steps.s3.desc') },
              { step: '4', title: t('about.process.steps.s4.title'), desc: t('about.process.steps.s4.desc') },
              { step: '5', title: t('about.process.steps.s5.title'), desc: t('about.process.steps.s5.desc') }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-enausa-navy rounded-full flex items-center justify-center text-white text-xl font-bold mx-auto mb-4 shadow-medium">
                  {item.step}
                </div>
                <h4 className="text-lg font-semibold text-enausa-navy mb-2">{item.title}</h4>
                <p className="text-sm text-enausa-gray">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;